<template>
  <el-main class="main-con el-main">
    <router-view />
  </el-main>
</template>

<script>
    export default {
        name: "Dealer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/Dealer.vue